import axios, {AxiosError, AxiosHeaders} from "axios";
import {persistentStorage} from "../build_constants.ts";
import Cookies from "js-cookie";

export class BlueshiftAPIConnectorUserNotActiveError {
}


export class BlueshiftAPIConnectorError {
    readonly cause: string;
    readonly message: string;

    constructor(cause: string, message: string) {
        this.cause = cause;
        this.message = message;
    }
}

export class BlueshiftAPIConnectorUnknownError {
    readonly axiosError: AxiosError;

    constructor(axiosError: AxiosError) {
        this.axiosError = axiosError;
    }

    get message(): string {
        if (this.axiosError.response) {
            return this.axiosError.response.data as string;
        } else {
            return this.axiosError.message;
        }

    }
}

export const restfulApiClient = {
    _createApiUrl(endpoint: string, version: number) {
        let warn = true;
        while (endpoint.startsWith("/")) {
            if (warn) {
                console.warn(`invalid api invoke url: ${endpoint}`);
            }
            endpoint = endpoint.substring(1);
            warn = false;
        }

        return "/api/v" + version + "/" + endpoint;
    },
    async get(endpoint: string, version: number) {
        try {
            return await axios.get(restfulApiClient._createApiUrl(endpoint, version));
        } catch (err) {
            const blueshiftApiConnectorError = restfulApiClient.axiosArrToBlueshiftApiConnectorError(err);
            if (blueshiftApiConnectorError)
                throw blueshiftApiConnectorError;
        }
    },

    async delete(endpoint: string, version: number) {
        try {
            return await axios.delete(restfulApiClient._createApiUrl(endpoint, version));
        } catch (err) {
            const blueshiftApiConnectorError = restfulApiClient.axiosArrToBlueshiftApiConnectorError(err);
            if (blueshiftApiConnectorError)
                throw blueshiftApiConnectorError;
        }
    },
    async post(endpoint: string, version: number, data: object | FormData | null) {
        try {
            return await axios.post<string | object>(restfulApiClient._createApiUrl(endpoint, version), data);
        } catch (err) {
            const blueshiftApiConnectorError = restfulApiClient.axiosArrToBlueshiftApiConnectorError(err);
            if (blueshiftApiConnectorError)
                throw blueshiftApiConnectorError;
        }
    },

    async patch(endpoint: string, version: number, data: object | FormData) {
        try {
            return await axios.patch(restfulApiClient._createApiUrl(endpoint, version), data);
        } catch (err) {
            const blueshiftApiConnectorError = restfulApiClient.axiosArrToBlueshiftApiConnectorError(err);
            if (blueshiftApiConnectorError)
                throw blueshiftApiConnectorError;
        }
    },

    async put(endpoint: string, version: number, data: object | FormData) {
        try {
            return await axios.put(restfulApiClient._createApiUrl(endpoint, version), data);
        } catch (err) {
            const blueshiftApiConnectorError = restfulApiClient.axiosArrToBlueshiftApiConnectorError(err);
            if (blueshiftApiConnectorError)
                throw blueshiftApiConnectorError;
        }
    },

    axiosArrToBlueshiftApiConnectorError(err: unknown) {
        if (err instanceof AxiosError) {
            const res = err.response!;
            const headers = res.headers as AxiosHeaders;
            const contentType = headers.get("content-type")! as string;

            if (contentType.toLocaleLowerCase() === "application/json") {
                const errData = err.response?.data["detail"] as Record<string, string | null>;

                if ("cause" in errData && "msg" in errData) {
                    return new BlueshiftAPIConnectorError(
                        errData["cause"]!,
                        errData["msg"]!
                    );
                }
            }

            return new BlueshiftAPIConnectorUnknownError(
                err
            );
        }
    }
}

export function createWebsocketAddr(endPoint: string): string {
    const protocol = window.location.protocol === 'https:' ? "wss://" : "ws://";
    return protocol + location.host + "/ws/" + endPoint.replace(/^\/+/, ''); // left / trim
}

/**
 * @param {String} endPoint
 * @returns {WebSocket}
 */
export function createWebsocket(endPoint: string): WebSocket {
    return new WebSocket(createWebsocketAddr(endPoint));
}

export function getParams() {
    let url = decodeURIComponent(location.href);
    url = decodeURIComponent(url);

    const paramStr: string = url.substring(url.indexOf('?') + 1, url.length);
    const paramArray: string[] = paramStr.split("&");

    let key, value;
    const params: { [key: string]: string } = {};
    for (let i = 0; i < paramArray.length; i++) {
        key = paramArray[i].split("=")[0];
        value = paramArray[i].split("=")[1];

        params[key] = value;
    }

    return params;
}

export function sessionToCookie() {
    Cookies.set('csrf', persistentStorage["csrf"], {expires: 1});
    Cookies.set('session_id', persistentStorage["session_id"], {expires: 1});
    Cookies.set('user_id', persistentStorage["user_id"], {expires: 1});
}

export function deleteSessionCookie() {
    Cookies.remove('csrf');
    Cookies.remove('session_id');
    Cookies.remove('user_id');
}

axios.interceptors.request.use((cfg) => {
    if (cfg.url?.includes("/api/v1/login") || cfg.url?.includes("/api/v1/logout")) {
        // console.info(`인증 필요 없음: ${cfg.url}`);
        return cfg;
    }

    if (persistentStorage["user_id"] && persistentStorage["session_id"] && persistentStorage["csrf"]) {
        cfg.headers["X-Auth-User-Id"] = persistentStorage["user_id"];
        cfg.headers["X-Session-Id"] = persistentStorage["session_id"];
        cfg.headers["X-Session-CSRF"] = persistentStorage["csrf"];
    } else {
        console.warn(`로그인 준비 안됨: ${cfg.url}`);
    }

    return cfg;
});